import ls from 'lib/core/storageFactory';
import { useEffect, useMemo, useState } from 'react';

const statusCodes = {
    0: 'Not Applicable',
    1: 'Not Processed',
    2: 'Processed Under Review',
    3: 'Rejected',
    4: 'Accepted',
}

export const useSessionReviewStatus = (shelfData, reasonCodes) => {
    const sessionReviewStatus = useMemo(() => {
      const status = { type: '', text: '' };
  
      if (Array.isArray(shelfData?.session_review_status) && reasonCodes?.length) {
        const reasonsByID = reasonCodes.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
  
        // status.text = shelfData.session_review_status.reduce((prev, curr) => {
        //   return prev + (reasonsByID[curr.session_review_status]?.code || '');
        // }, '');
  
        // status.type = status.text.toLowerCase().includes('accept')
        //   ? 'accept'
        //   : status.text.toLowerCase().includes('reject')
        //   ? 'reject'
        //   : '';

        status.type = shelfData.session_review_status[0]?.session_review_status === 4 ? 'accept' : shelfData.session_review_status[0]?.session_review_status === 3? 'reject': 'not_reviewed';
        status.color = status.type === 'accept' ? '#4CAF50' : status.type === 'reject' ? 'red' : '#FF9800';
        status.text = shelfData.session_review_status.reduce((prev, curr) => {
          return [...new Set([...prev, curr.reasons])];
        }, []).join(', ');

        if (status.type === 'not_reviewed' && !status.text) {
          status.text = statusCodes[shelfData.session_review_status[0]?.session_review_status];
        }
      }
  
      return status;
    }, [shelfData, reasonCodes]);
  
    return { sessionReviewStatus };
};
  

const useReasonCodes = () => {
  const [reasonCodes, setReasonCodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReasonCodes = async () => {
      try {
        const res = await fetch(`https://${ls.get('client')}.${process.env.REACT_APP_SHELF_API_REDIRECT_URI}/api/v1/manual-qa/reason-codes/`, {
          headers: {
            Authorization: `Token ${ls.get('authToken')}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await res.json();
        setReasonCodes(data);
      } catch (err) {
        console.error('Error fetching reason codes:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchReasonCodes();
  }, []);

  return { reasonCodes, loading };
};

export default useReasonCodes;

export function buildManualQaReviewList(items) {
  const acceptGroup = { label: 'Accept', selectable: false, children: [] };
  const rejectGroup = { label: 'Reject', selectable: false, children: [] };

  // Prepare subgroups for PQ and AI codes
  const pqGroup = { label: 'PQ Codes', selectable: false, children: [] };
  const aiGroup = { label: 'AI Codes', selectable: false, children: [] };

  (items || []).forEach(item => {
    const code = item.code;
    const value = item.id;
    const node = { label: code, value, other: item };

    if (code.toLowerCase().includes('accept')) {
      acceptGroup.children.push(node);
    } else if (code.toLowerCase().includes('reject')) {
      if (code.toLowerCase().includes('pq_codes')) {
        pqGroup.children.push(node);
      } else if (code.toLowerCase().includes('ai_codes')) {
        aiGroup.children.push(node);
      } else {
        rejectGroup.children.push(node);
      }
    }
  });

  // Only include PQ or AI groups if they have children
  if (pqGroup.children.length) rejectGroup.children.push(pqGroup);
  if (aiGroup.children.length) rejectGroup.children.push(aiGroup);

  
  
  return [acceptGroup, rejectGroup];
}